// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:33:09

export default {
  "id": "squid-escape-game",
  "slug": "squid-escape-game",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/60ced9a2a44449fba49fe3694272f557-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/60ced9a2a44449fba49fe3694272f557/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Squid Escape Game",
      "description": "You must escape from this iron-covered labyrinth prison. Both blue players need to escape the prison. You must collect all the geometric shapes. Collect all the shapes and find both keys. Find the keys and run to the door. Be very careful, there are thorny obstacles on the ground. Don't stray too far from your friend; if you lose each other, you will lose the game.",
      "instructions": "*Use the WASD keys and the Arrow keys to move. \n*Both players must reach the door safely and complete the level.\n*You must collect all the shapes in the level.",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "2d",
        "2players",
        "arcade",
        "escape",
        "squidgame"
      ]
    },
    "zh-CN": {
      "title": "章鱼逃脱游戏",
      "description": "你们必须逃离这个铁皮覆盖的迷宫监狱。两位蓝色玩家都需要逃离监狱。你们必须收集所有几何形状。收集所有形状并找到两把钥匙。找到钥匙后，跑到门口。要非常小心，地面上有带刺的障碍物。不要离你的朋友太远；如果你们彼此失去了，你们就会输掉游戏。",
      "instructions": "*使用WASD键和箭头键进行移动。\n*两名玩家都必须安全到达门口并完成关卡。\n*你必须收集关卡中的所有形状。",
      "genres": [
        "冒险"
      ],
      "tags": [
        "2D",
        "2人",
        "街机",
        "逃脱",
        "鱿鱼游戏"
      ]
    },
    "zh-TW": {
      "title": "烏魚逃亡遊戲",
      "description": "你必须從這個鐵板覆蓋的迷宮監獄逃脫。兩位藍色玩家都需要逃離監獄。你必須收集所有的幾何形狀。收集所有形狀並找到兩把鑰匙。找到鑰匙後跑到門口。要非常小心，地面上有釘子般的障礙物。不要離你的朋友太遠；如果失去彼此，你將會輸掉遊戲。",
      "instructions": "*使用 WASD 鍵和方向鍵來移動。\n*兩位玩家必須安全地到達大門並完成關卡。\n*你必須收集關卡中所有的圖形。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "2D",
        "雙人",
        "街機",
        "逃離",
        "魚沼遊戲"
      ]
    },
    "zh-HK": {
      "title": "烏魚逃亡遊戲",
      "description": "您必須從這個鐵板覆蓋的迷宮監獄逃離。兩位藍色玩家都需要逃離監獄。您必須收集所有幾何形狀。收集所有形狀並找到兩把鑰匙。找到鑰匙並跑到門口。請非常小心，地上有釘子般的障礙物。不要離開您的朋友太遠；如果彼此失散，您將會輸掉遊戲。",
      "instructions": "*使用WASD及方向鍵移動。\n*兩名玩家必須安全抵達大門並完成關卡。\n*你必須收集關卡中所有的圖形。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "2D",
        "2人玩",
        "街機",
        "逃離",
        "章魚遊戲"
      ]
    },
    "ja": {
      "title": "クラゲ脱出ゲーム",
      "description": "この鋼鉄で覆われた迷路刑務所から逃げる必要があります。両方の青いプレイヤーは刑務所から逃げなければなりません。すべての幾何学形状を収集する必要があります。すべての形状を収集し、両方の鍵を見つけます。鍵を見つけ、ドアに向かって走ります。非常に慎重に、地面には棘のある障害物があります。友達から遠ざからないでください；お互いを見失ったら、ゲームを失います。",
      "instructions": "*WASDキーや矢印キーを使用して移動してください。\n*両プレイヤーは安全にドアに到着し、レベルをクリアする必要があります。\n*レベル内のすべての形状を収集する必要があります。",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "2D",
        "2人プレイヤー",
        "アーケード",
        "脱出",
        "くじれん坊ゲーム"
      ]
    },
    "ko": {
      "title": "오징어 탈출 게임",
      "description": "이 아이언으로 덮인 랩티락 감옥에서 탈출해야 합니다. 블루 플레이어 두 명이 감옥에서 탈출해야 합니다. 모든 기하학적 형상을 모으세요. 모든 형상을 모으고 두 개의 열쇠를 찾으세요. 열쇠를 찾고 문으로 달려가세요. 매우 주의하세요, 바닥에 가시뭉치가 있습니다. 친구와 멀리 떨어지지 마세요; 서로 찾지 못하면 게임을 잃게 됩니다.",
      "instructions": "* WASD 키와 방향키를 사용하여 이동하세요.\n* 두 플레이어 모두 안전하게 문에 도달하고 레벨을 완료해야 합니다.\n* 레벨에서 모든 모양을 모아야 합니다.",
      "genres": [
        "모험"
      ],
      "tags": [
        "2D",
        "2인",
        "아케이드",
        "탈출",
        "오징어게임"
      ]
    },
    "fr": {
      "title": "Échappée du Calamar",
      "description": "Vous devez vous échapper de cette prison couverte de fer. Les deux joueurs bleus doivent s'échapper de la prison. Vous devez collecter toutes les formes géométriques. Collectez toutes les formes et trouvez les deux clés. Trouvez les clés et courrez vers la porte. Soyez très prudent, il y a des obstacles épineux au sol. Ne vous éloignez pas trop de votre ami ; si vous vous perdez l'un de l'autre, vous perdez le jeu.",
      "instructions": "*Utilisez les touches WASD et les flèches directionnelles pour vous déplacer.\n*Les deux joueurs doivent atteindre la porte en sécurité et terminer le niveau.\n*Vous devez collecter toutes les formes du niveau.",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "2d",
        "2 joueurs",
        "arcade",
        "évasion",
        "jeu-squidgame"
      ]
    }
  }
};
